import type { RateProviderUsageTranslations } from "../interfaces/rateProviderUsage";

export const rateProviderUsageTranslations: RateProviderUsageTranslations = {
  // Page
  page_title: "Consumo dos provedores de taxas",
  page_subtitle: "Quantas requisições gastamos com cada provedor de taxas de câmbio, mês a mês",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar os contadores de consumo",

  why_heading: "Por que este contador e não o histórico de taxas",
  why_text:
    "Os provedores são consultados em ordem e o primeiro que responde vence, dentro da mesma requisição. Se o principal falha, gasta a cota do mesmo jeito, mas a taxa guardada é a do reserva. Aqui conta-se cada requisição que sai, respondida ou não.",

  month_label: "Mês",

  error_load: "Não conseguimos carregar o consumo",
  error_load_detail: "Tente de novo. Se continuar falhando, verifique se o serviço está disponível.",
  error_retry: "Tentar de novo",

  // Stat strip
  kpi_month_requests: "Requisições do mês",
  kpi_month_requests_meta: "Total de {{month}}, somando todos os provedores",
  kpi_month_failed: "Falhadas",
  kpi_month_failed_meta: "Gastam cota igual às bem-sucedidas",
  kpi_primary: "Provedor principal",
  kpi_primary_none: "Nenhum configurado",
  kpi_primary_meta: "O primeiro a ser consultado",

  // Failover ladder
  ladder_heading: "Ordem de consulta",
  ladder_description:
    "De cima para baixo, a ordem em que são consultados. Cada um mostra o que custou e se respondeu.",
  ladder_role_primary: "Principal",
  ladder_role_fallback: "Reserva {{position}}",
  ladder_role_retired: "Fora da ordem",
  ladder_retired_hint: "Gastou cota no período mas não está mais configurado",
  ladder_never_answered: "Não resolveu nenhuma taxa",
  ladder_bar_aria: "{{success}} resolvidas e {{failed}} falhadas",
  ladder_resolved: "{{value}} resolvidas",
  ladder_failed: "{{value}} falhadas",
  ladder_error_unknown: "sem código",
  ladder_no_requests: "Sem requisições no período",
  ladder_requests_label: "requisições",

  empty_title: "Sem requisições registradas",
  empty_description:
    "Nenhum provedor foi consultado neste mês. Se você acabou de implantar, o contador começa a partir daí.",

  // Month over month
  monthly_heading: "Por mês",
  monthly_description: "Para conciliar com a fatura e ver se o consumo está subindo.",
  monthly_column_month: "Mês",
  monthly_column_total: "Total",
  monthly_failed_suffix: "({{value}} falhadas)",
  monthly_empty_cell: "—",
  monthly_empty_title: "Ainda sem histórico",
  monthly_empty_description: "Ainda não há meses com requisições registradas.",

  // Errors
  errors_heading: "Erros do mês",
  errors_description: "Por que falharam, para distinguir uma implantação ruim de uma cota esgotada.",
  errors_none: "Nenhum provedor falhou neste mês.",
  errors_http_status: "· HTTP {{status}}",
  errors_detail_message: "Mensagem",
  errors_detail_url: "URL chamada",
  errors_detail_response: "Resposta do provedor",
  errors_occurrences: "{{value}} vezes",
  errors_last_at: "Último: {{at}}",
};
